import styled from 'styled-components';
import Icon from '../Icon';

export const Container = styled.div`
  display: block;
  position: relative;
`;

export const LoaderPadding = styled.div`
  padding: 10px 15px;
`;

export const AutocompleteInput = styled.input`
  &::placeholder {
    color: transparent;
  }

  position: relative;
  z-index: 2;
  width: 100%;
  height: 52px;
  color: var(--carbone100);
  padding: 25px 40px 10px 16px;
  text-overflow: ellipsis;
  border: 1px solid #c7cfd9;
  box-sizing: border-box;
  border-radius: 8px;

  &:focus {
    border-color: var(--theme-palette-inputs-stroke);
    outline: none;

    & + label {
      font-size: 12px;
      top: 16px;
      transition: all 0.2s;
    }
  }

  &:before {
    content: 'test';
    display: block;
    background-color: red;
  }

  &:not(:placeholder-shown):not(:focus) + label {
    top: 16px;
    font-size: 12px;
  }

  & + label {
    cursor: text;
    position: absolute;
    color: var(--carbone70);
    font-size: 14px;
    left: 16px;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 2;
    transition: all 0.2s;
  }
`;

export const SuggestionsContainer = styled.div`
  z-index: 1;
  margin-top: -6px;
  max-height: 185px;
  overflow-y: scroll;
  position: absolute;
  display: block;
  background: white;
  width: 100%;
  border: 1px solid #e2e5e9;
  box-sizing: border-box;
  box-shadow: 0px 3px 18px rgba(0, 0, 0, 0.04);
  border-top: none;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  text-align: left;
`;

export const SuggestionItem = styled.div`
  cursor: pointer;

  &:first-child {
    margin-top: 8px;
  }
  padding: 8px 16px 5px;

  hr {
    margin-bottom: 0;
    border: none;
    border-top: 1px solid var(--aluminium20);
  }

  & > p {
    transition: all 0.4s;
    margin: 0;
    padding: 0;
    font-weight: normal;
    font-size: 13px;
    line-height: 20px;

    &:first-child {
      color: var(--carbone100);
    }
    &:last-of-type {
      font-size: 12px;
      line-height: 16px;
      color: var(--carbone70);
    }
  }

  &:hover > p {
    color: var(--carbone120);
  }
`;

export const GeoIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 14px;
  fill: var(--theme-palette-brand-color);
  font-size: 20px;
  z-index: 2;
  transition: all 0.2s;

  &:hover {
    cursor: pointer;
    font-size: 25px;
    right: 12px;
    fill: var(--theme-palette-brand-bg-hover);
    transition: all 0.2s;
  }
`;
